import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { AuthenticateRequest } from '../_models/Authentication/authenticate-request';
import { RegistrationRequest } from '../_models/Authentication/registration-request';
import { UserModel } from '../_models/User/UserModel';
import { ApiService } from './api.service';
import { TokenStorageService } from './token-storage.service';
import { UserService } from './user.service';
import { Router } from '@angular/router';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { AnalyticsConstants } from '../global-constants/analytics';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import { JwtHelperService } from '@auth0/angular-jwt';
import { RoleTypeEnum } from '../admin-panel/enums/role-type.enum';
import { RoleNameEnum } from '../admin-panel/enums/role-name.enum';
import { SocialRegisterRequestModel } from '../_models/Authentication/social-register-request';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user = new BehaviorSubject<UserModel | null>(null);
  _isLoggedIn$ = new BehaviorSubject<boolean>(false);
  _isSuperAdmin$ = new BehaviorSubject<boolean>(false);
  _isAdvertiser$ = new BehaviorSubject<boolean>(false);
  _isTechSupport$ = new BehaviorSubject<boolean>(false);
  private readonly TOKEN_NAME = 'auth-token';
  public isLoggedIn$ = this._isLoggedIn$.asObservable();
  public isSuperAdmin$ = this._isSuperAdmin$.asObservable();
  get token(): any {
    return localStorage.getItem(this.TOKEN_NAME);
  }

  constructor(
    private apiService: ApiService, 
    private userService: UserService, 
    private tokenStorage: TokenStorageService, 
    private router: Router, 
    private analytics: AngularFireAnalytics,
    private _jwtHelperService: JwtHelperService,
    private fireAuth: AngularFireAuth) 
    { 
    const token = this.tokenStorage.getToken();
    this._isLoggedIn$.next(!!this.token);
    if (token != null) {
      var tokenDecoded = this._jwtHelperService.decodeToken(token);
      const ustp = tokenDecoded.ustp.split(',').map((x: string) => +x);
      const rlnm = tokenDecoded.rlnm.split(',').map((x: string) => +x);
      if (ustp.includes(RoleTypeEnum.Admin)) {
        this._isSuperAdmin$.next(true);
        if(rlnm.includes(RoleNameEnum.Techsupport)) {
          this._isTechSupport$.next(true);
        }
      } else if(ustp.includes(RoleTypeEnum.Advertiser)) {
        this._isAdvertiser$.next(true);
      }
    } else {
      this._isSuperAdmin$.next(false);
      this._isAdvertiser$.next(false);
      this._isTechSupport$.next(false);
    }

  }

  register(registerCredentials: RegistrationRequest) {
    return this.apiService.register(registerCredentials)
      .pipe(
        tap((response: any) => { //write response models
          this._isLoggedIn$.next(true);
          this.tokenStorage.saveToken(response.jwtToken);
          this.tokenStorage.saveRefreshToken(response.refreshToken);
          this.handleAuthentication();
        })
      );
  }

  registerWithFacebook(socialRegisterCredetials: SocialRegisterRequestModel){
    return this.apiService.registerSociaLogin(socialRegisterCredetials)
      .pipe(
        tap((response: any) => {
          this._isLoggedIn$.next(true);
          this.tokenStorage.saveToken(response.jwtToken);
          this.tokenStorage.saveRefreshToken(response.refreshToken);
          this.handleAuthentication();
        })
      )
  }

  facebookAuth() {
    return this.socialAuthLogin(new firebase.auth.FacebookAuthProvider());
  }

  googleAuth() {
    return this.socialAuthLogin(new firebase.auth.GoogleAuthProvider());
  }
  
  socialAuthLogin(provider:any) {
    return this.fireAuth.signInWithPopup(provider);
  }

  autoLogin() {
    // @ts-ignore
    const userData: UserModel = JSON.parse(localStorage.getItem('userData'))
    if (!userData) return;
    const loadedUser = new UserModel(
      userData.address,
      userData.businessTypes,
      userData.canReceiveNotifications,
      userData.companyId,
      userData.companyName,
      userData.taxNumber,
      userData.user
    )
    if (loadedUser) {
      this.user.next(loadedUser);
    }
  }

  getUserid() {
    const userData: UserModel = JSON.parse(localStorage.getItem('userData') as string)
    if (!userData) return;
    return userData.user?.id;
  }

  handleAuthentication() {
    this.userService.getUserProfile().subscribe((result => {
      const user = new UserModel(
        result.address,
        result.businessTypes,
        result.canReceiveNotifications,
        result.companyId,
        result.companyName,
        result.taxNumber,
        result.user
      );
      this.user.next(user);
      localStorage.setItem('userData', JSON.stringify(user));
    }))
  }

  handleAdminAuthentication() {
    this.userService.getAdminUserProfile().subscribe((result => {
      const user = new UserModel(
        result.address,
        result.businessTypes,
        result.canReceiveNotifications,
        result.companyId,
        result.companyName,
        result.taxNumber,
        result
      );
      this.user.next(user);
      localStorage.setItem('userData', JSON.stringify(user));
    }))
  }

  logout() {
    this.user.next(new UserModel());
    this._isLoggedIn$.next(false);
    // localStorage.removeItem('userData');//
    this.tokenStorage.signOut();
    this.analytics.logEvent(AnalyticsConstants.logoutEvent);
    this.router.navigate(['/login']);
  }
  
  showEditProfile = new EventEmitter<boolean>()
  changeLangPrivacyPolicyEventEmitter = new EventEmitter<boolean>();
  hideNavigationMenuEventEmitter = new EventEmitter<boolean>();
}